import CollapsiblePanel from "../../../components/collapsible-panel/CollapsiblePanel";
import TodaysAppointmentsSection from "./appointments/TodaysAppointmentsSection";
import CollapsedAppointmentsIndicator from "./appointments/CollapsedAppointmentsIndicator";
import { useTodaysAppointmentCards } from "./appointments/useTodaysAppointmentCards";

/**
 * The collapsible right-hand rail on the Home page.
 *
 * This is a FRAME that takes sections, not an appointments-only panel (Maria's
 * answer #8) — cancelled appointments and anything else the rail later carries
 * are added as siblings here. State is owned by Home because collapsing the rail
 * widens the worklist. It always starts expanded and the state is deliberately
 * NOT persisted between visits (answer #6).
 *
 * The rail's surface is `k-card` — the platform's white-on-grey content panel,
 * the same class UiCard renders and every other page sits its content on.
 * Home was the only page whose content sat straight on the grey background.
 *
 * Collapsed, the rail is a slim white strip on the far right with the expand
 * chevron and a calendar icon carrying today's appointment count.
 */

export interface HomeRailProps {
	expanded: boolean;
	onToggle: (expanded: boolean) => void;
}

const HomeRail = ({ expanded, onToggle }: HomeRailProps) => {
	const { cards, isLoading, isError } = useTodaysAppointmentCards();

	return (
		<CollapsiblePanel
			side="right"
			className="home-rail k-card"
			expanded={expanded}
			onToggle={onToggle}
			testId="home-rail"
		>
			<div className="home-rail__content">
				<TodaysAppointmentsSection
					cards={cards}
					isLoading={isLoading}
					isError={isError}
				/>
			</div>
			{!expanded && (
				<CollapsedAppointmentsIndicator
					count={cards.length}
					showCount={!isLoading && !isError}
				/>
			)}
		</CollapsiblePanel>
	);
};

export default HomeRail;
